<template>
  <div :class="styleMain">
    <div class="name">{{ teamName }}</div>
    <div class="score">{{ score }}</div>
  </div>
</template>

<script>
export default {
  name: 'SportFootballMatchTeamHeader',
  props: {
    match: Object,
    team: Object
  },
  computed: {
    teamName () { return this.team?.name },
    score () { return this.team?.id === this.match?.teamHomeId ? this.match?.scoreHome : this.match?.scoreAway },

    styleMain () { return ['sportFootballMatchTeamHeader', this.match?.homeAway(this.team)] }
  }
}
</script>

<style>
.sportFootballMatchTeamHeader {
  flex:initial;
  display: flex;
  height: 125px;
  color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
}

.sportFootballMatchTeamHeader.away {
  flex-flow: row-reverse;
}

.sportFootballMatchTeamHeader .name {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  font-weight: bold;
  font-size: 28px;
}

.sportFootballMatchTeamHeader .score {
  display: flex;
  width: 50px;
  background-color: black;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 28px;
}
</style>
